import { Children, cloneElement } from 'react';

import s from './PropertyList.module.scss';

type Props = {
  title: string;
  children: React.ReactNode;
};

export const PropertyList = ({ title, children }: Props) => {
  const childArray = Children.toArray(children);
  return (
    <div className={s.propertyList}>
      <p className={s.propertyList__title}>{title}</p>
      <ul className={s.propertyList__items}>
        {childArray.map((child, i) => (
          <li className={s.properties__item} key={i}>
            {cloneElement(child as React.ReactElement)}
          </li>
        ))}
      </ul>
    </div>
  );
};
